import * as environmentLocal from './environment.local';
export const environment = environmentLocal.environment;
